module.exports = __webpack_public_path__ + "static/img/Pig.2fe1ff1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal/Pig.svg
// module id = 1364
// module chunks = 0